<nav
  class="max-w-[83px] flex justify-start mb-6 px-4 py-2 bg-white rounded-xl shadow-sm border border-gray-100 transition-all duration-200"
>
  <button
    type="button"
    (click)="goBack()"
    class="flex items-center gap-2 text-[#181F38] font-medium hover:text-white hover:bg-[#181F38] px-4 py-2 rounded-lg transition-all duration-200"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="w-4 h-4"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
    </svg>
  </button>
</nav>
